import { LOW_PRICE, MID_PRICE, HIGH_PRICE } from '../constants';
import getOption from './getOption';

var price = function price(_ref) {
  var label = _ref.label,
      values = _ref.values,
      urlParams = _ref.urlParams;
  var param = 'priceFilter';
  return {
    expand: true,
    filter: function filter(product, value) {
      var giftCard = product.giftCard;
      var price = product.colorways.edges[0].node.variant.price;

      if (giftCard) {
        return true;
      }

      if (value === LOW_PRICE && price <= 50) {
        return true;
      }

      if (value === MID_PRICE && price >= 50 && price <= 100) {
        return true;
      }

      if (value === HIGH_PRICE && price >= 100) {
        return true;
      }

      return false;
    },
    label: label,
    param: param,
    options: values,
    selected: getOption(values, urlParams.get(param))
  };
};

export default price;